import { createStyles, makeStyles } from '@material-ui/styles';
import { TopBarStyleProps } from './TopBar.view';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: (props: TopBarStyleProps) => {
        if (props.isTablet && props.isPublicShop) return 'center';
        if (props.isDesktop && props.isPublicShop) return 'space-between';
        if (props.isDesktop) return 'flex-end';
        return 'space-between';
      },
      gap: (props: TopBarStyleProps) => {
        if (!props.isTablet && props.isPublicShop) return '10px';
      },
      position: 'fixed',
      right: '0',
      top: '0',
      left: '0',
      zIndex: 10,
      padding: (props: TopBarStyleProps) => {
        if (props.isTablet) return '10px 0px 20px 0px';
        if (props.isPublicShop) return '20px 20px 20px 20px';
        return '20px 20px 20px 280px';
      },
      background:
        'linear-gradient(180deg, #F1F7FF 80%, rgba(241, 247, 255, 0) 100%)',
      '@media (max-width: 769px)': {
        left: '0',
        justifyContent: 'flex-end'
      }
    },
    rightCol: {
      display: 'flex',
      gap: '20px',
      '@media (max-width: 769px)': {
        width: '100%',
        justifyContent: 'flex-end'
      }
    },
    headerText: {
      display: 'flex',
      '@media (max-width: 1280px)': {
        display: 'none'
      }
    },
    mobileMenu: {
      display: 'flex',
      gap: '20px',
      '@media (min-width: 769px)': {
        display: 'none'
      }
    },
    desktopMenu: {
      display: 'flex',
      gap: '20px',
      '@media (max-width: 768px)': {
        display: 'none'
      }
    },
    icons: {
      display: 'flex',
      gap: '20px'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
